module.exports = __webpack_public_path__ + "img/ncku_logo.bd791008.jpg";